import React from 'react'
import { IconButton } from '@material-ui/core'
import ClearIcon from '@material-ui/icons/Clear'

import { FilterData, indextypes, regions, states } from '../../constants/Filter'

interface SelectedFiltersProps {
  selectedFilter: string[]
  setFilter: React.Dispatch<React.SetStateAction<string[]>>
  filterConstants: FilterData[]
}

export const SelectedFilters: React.FC<SelectedFiltersProps> = ({ setFilter, selectedFilter, filterConstants }) => {
  const filterSelection = (currentSelection: string) => {
    const filtered = selectedFilter.filter((s) => {
      return currentSelection !== s
    })
    return setFilter(filtered.length ? filtered : [filterConstants[0].value])
  }

  return (
    <>
      {selectedFilter.length >= 1 &&
        selectedFilter.map((currentSelection) => {
          const selectionDetail = filterConstants.filter(
            (current: { value: string }) => current.value === currentSelection,
          )

          if (
            selectionDetail.length === 0 ||
            (selectedFilter.length === 1 && selectedFilter[0] === states[0].value) ||
            (selectedFilter.length === 1 && selectedFilter[0] === regions[0].value) ||
            (selectedFilter.length === 1 && selectedFilter[0] === indextypes[0].value)
          ) {
            return <> </>
          }
          return (
            <div key={currentSelection} data-testid="test-filter-option" className="selected-filter-option">
              <div className="selected-filter-option-content">
                <IconButton
                  onClick={() => filterSelection(currentSelection)}
                  className="selected-filter-option-icon-button"
                >
                  <ClearIcon className="selected-filter-option-cross" />
                </IconButton>
                {selectionDetail[0].label}
              </div>
            </div>
          )
        })}
    </>
  )
}

export default SelectedFilters
